import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useRef } from "react";
import { GlobalShell } from "~/components/GlobalShell";
import { useRouter, useSearchParams } from "~/components/navigation";
import { trpc } from "~/utils/trpc.client";

export const Route = createFileRoute("/reset-password-confirm")({
  component: ResetPasswordConfirmPage,
});

function ResetPasswordConfirmPage() {
  const router = useRouter();
  const token = useSearchParams().get("token");
  const verifyToken = trpc.auth.verifyForgotPasswordToken.useMutation();
  const fired = useRef(false);

  useEffect(() => {
    if (fired.current) return;
    fired.current = true;

    if (!token) {
      router.replace("/reset-password-failure");
      return;
    }

    verifyToken.mutate(
      { token },
      {
        onSuccess: () => {
          router.replace(
            `/reset-password-success-set-password?token=${encodeURIComponent(token)}`,
          );
        },
        onError: () => {
          router.replace("/reset-password-failure");
        },
      },
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <GlobalShell>
      <div className="flex grow items-center justify-center">
        <div className="card bg-base-100 w-96 shadow-xl max-w-[90vw]">
          <div className="card-body">
            <p>Verifying...</p>
          </div>
        </div>
      </div>
    </GlobalShell>
  );
}
